import { CampaignSubSource } from 'utils/constants/campaign';
import { previousMonth } from 'utils/date';

import createReducer, { ActionCreatorHelper } from 'store/createReducer';

interface AccountStatisticsData {
    amount: number;
    clicks: number;
    impressions: number;
    source: CampaignSubSource;
}

type AccountId = '';
type FromDate = Date;
type ToDate = Date;
type IsLoad = boolean;

// ----------------------- actions -------------------------------------
const SET_ACCOUNT_STATISTICS_DATES = 'SET_ACCOUNT_STATISTICS_DATES';
const SET_ACCOUNT_STATISTICS_ACCOUNT_ID = 'SET_ACCOUNT_STATISTICS_ACCOUNT_ID';
const SET_ACCOUNT_STATISTICS_DATA = 'SET_ACCOUNT_STATISTICS_DATA';
const SET_LOAD_ACCOUNT_STATISTICS_DATA = 'SET_LOAD_ACCOUNT_STATISTICS_DATA';

interface PayloadTypes {
    [SET_ACCOUNT_STATISTICS_DATES]: { from: FromDate; to: ToDate };
    [SET_ACCOUNT_STATISTICS_ACCOUNT_ID]: AccountId;
    [SET_ACCOUNT_STATISTICS_DATA]: AccountStatisticsData[];
    [SET_LOAD_ACCOUNT_STATISTICS_DATA]: IsLoad;
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setAccountStatisticsDates = ActionCreator(SET_ACCOUNT_STATISTICS_DATES);
export const setAccountStatisticsAccountId = ActionCreator(SET_ACCOUNT_STATISTICS_ACCOUNT_ID);
export const setAccountStatisticsData = ActionCreator(SET_ACCOUNT_STATISTICS_DATA);
export const setLoadAccountStatisticsData = ActionCreator(SET_LOAD_ACCOUNT_STATISTICS_DATA);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface AccountsStatisticsState {
    from: FromDate;
    to: ToDate;
    accountId: AccountId;
    accountStatisticsData: AccountStatisticsData[];
    isLoad: IsLoad;
}

export const ACCOUNT_STATISTICS_INITIAL_STATE: AccountsStatisticsState = {
    from: previousMonth,
    to: new Date(),
    accountId: '',
    accountStatisticsData: [],
    isLoad: false,
};

export default createReducer<AccountsStatisticsState, PayloadTypes>(ACCOUNT_STATISTICS_INITIAL_STATE, {
    [SET_ACCOUNT_STATISTICS_DATES]: (state, { payload }) => ({
        ...state,
        from: payload.from,
        to: payload.to,
    }),
    [SET_ACCOUNT_STATISTICS_ACCOUNT_ID]: (state, { payload }) => ({
        ...state,
        accountId: payload,
    }),
    [SET_ACCOUNT_STATISTICS_DATA]: (state, { payload }) => ({
        ...state,
        accountStatisticsData: payload,
    }),
    [SET_LOAD_ACCOUNT_STATISTICS_DATA]: (state, { payload }) => ({
        ...state,
        isLoad: payload,
    }),
});
// ----------------------- /reducer --------------------------------------
